import styled from 'styled-components'

export const WaitingAnalysisButtom = styled.div`
  display: flex;
  gap: 4px;
  justify-content: flex-end;

  button {
    width: 150px;
    margin: 4px 0px 0px 0px;
    height: 36px;
  };
`
